import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { AiOutlineCustomerService } from "react-icons/ai"; // Ícono de soporte
import { theme } from "../../styles/theme";
import { getLabelById, getUserInfo } from "../../utilities/helpers";
import useGetProfileUserSummary from "../../pages/Platform/hooks/useGetProfileUserSummary";
import useGetPhoneCode from "../../core/hooks/useGetPhoneCode";
import { Tooltip } from "antd";

const PopupContainer = styled.div`
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: ${theme.zIndex.toast};
  background-color: ${theme.colors.red};
  color: ${theme.colors.white};
  width: 60px;
  height: 60px;
  border-radius: 50%;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: transform 0.3s ease, opacity 0.3s ease;

  &:hover {
    transform: scale(1.05);
    opacity: 0.95;
    cursor:  pointer
  }
`;

const FixedPopup = () => {
    const { nameid } = getUserInfo();
    const getProfileUserSummary = useGetProfileUserSummary(nameid);
    const { data } = getProfileUserSummary;
    const [dataProfile, setDataProfile] = useState({});
    const getPhoneCode = useGetPhoneCode();
    const { data: dataPhonecode, isSuccess: isSuccessPhoneCode } = getPhoneCode;
    const [optionsCodes, setOptionsCodes] = useState([]);

    useEffect(() => {
        if(data) {
          setDataProfile({
            phoneNumber: data?.data?.result?.phoneNumber,
            ind: getLabelById(data?.data?.result?.phoneCodeId, optionsCodes),
            email: data?.data?.result?.email,
            address: data?.data?.result?.address,
            name: data?.data?.result?.name,
            lastName: data?.data?.result?.lastName,
            userCode: data?.data?.result?.userId
          });
        } else {
          setDataProfile(null);
        }
    }, [data]);

    const handleAction = () => {
        const phoneNumber = process.env.REACT_APP_PHONE_SUPPORT || "50230645978";
        const message = dataProfile
        ? `Hola, necesito información o asistencia.\n\n` +
          `Nombre: ${dataProfile?.name || ""} ${dataProfile?.lastName || ""}\n` +
          `Correo: ${dataProfile?.email || ""}\n` +
          `Teléfono: ${dataProfile?.phoneNumber || ""}\n\n` +
          `Gracias.`
        : `Hola, necesito información o asistencia, pero no he iniciado sesión.\n\n` +
          `¿Podrían orientarme?\n\n` +
          `Gracias.`;

        const encodedMessage = encodeURIComponent(message);
        const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
        window.open(whatsappURL, "_blank"); 
    }

    return (
        <Tooltip title="Escríbenos por WhatsApp">
             <PopupContainer onClick={handleAction}>
                <AiOutlineCustomerService size={30} />
            </PopupContainer>   
        </Tooltip>
    );
};

export default FixedPopup;
